import React from 'react';
import { FieldRenderProps } from 'react-final-form';

import { SFormTextField } from 'components/styled';

type InputType = 'number' | 'text' | 'password' | 'textarea';

const TextFieldFinalFormWrapper = ({
  input,
  placeholder,
  meta,
  label,
  type,
  ...rest
}: FieldRenderProps<string>) => (
  <SFormTextField
    error={meta.modified ? meta.error : undefined}
    label={label}
    placeholder={placeholder}
    type={input.type as InputType}
    value={input.value}
    onChange={event => input.onChange(event)}
    {...rest}
  />
);

export default TextFieldFinalFormWrapper;
